import { Outlet } from 'react-router-dom';

function PublicMenuLayout() {
  return <Outlet />;
}

export default PublicMenuLayout;
